import * as _ from 'lodash';

import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UserService } from '../../../services/core.user.service';
import { StateService } from '@uirouter/angular';
import { GfTranslateService } from '../../../services/core.translate.service';
import { UiService } from '../../../services/core.ui.service';
import { GfTitleService } from '../../../services/core.title.service';
import { TourService } from '../../tour/tour.service';
import { SiteConfigService } from '../../../services/core.site-config.service';

@Component({
    selector: 'new-user',
    template: require('./index.html')
})
export class NewUserComponent implements OnInit, AfterViewInit {

    siteConfig: any = null;
    // user => profile
    user: any = {};

    hostName: string = '';
    siteName: string = '';
    appRelease: string = '';
    appEnvironment: string = '';
    appVersion: string = '';
    appVersionDate: string = '';
    avatarUrl: string = '';
    greeting: string = '';
    nobody: any = null;
    userStart: string = '';
    hasProjects: boolean = false;
    options: any = null;
    autoStartTour: boolean;

    constructor(
        private siteConfigService: SiteConfigService,
        private window: Window,
        public stateService: StateService, 
        private userService: UserService,
        private tourService: TourService,
        private gfTranslateService: GfTranslateService,
        private uiService: UiService,
        private titleService: GfTitleService) {
    }

    ngOnInit() {
        this.siteConfig = this.siteConfigService.siteConfig;
        this.user = this.userService.getUser();

        this.hostName = _.get(this.siteConfig, 'hostName', 'localhost');

        this.siteName = _.get(
            this.siteConfig, 'siteName', this.hostName
        );

        this.appRelease = _.get(this.siteConfig, 'appRelease', '');
        this.appEnvironment = _.get(this.siteConfig, 'appEnvironment', 'production');
        this.appVersion = _.get(this.siteConfig, 'appVersion', '');
        this.appVersionDate = _.get(this.siteConfig, 'appVersionDate', '');

        const unixName = this.userService.session.getUnixName();
        this.avatarUrl = `/api/user/${unixName}/avatar`;

        this.greeting = this.user.firstname;
        if (this.greeting == '') {
            this.greeting = this.user.unixName;
        }

        this.nobody = this.userService.getNobody();

        this.userStart = 'home';

        this.hasProjects = false;
        this.userService.projects.get(this.userService.session.getUnixName())
            .then( (response) => {
                if (response.success) {
                    this.hasProjects = _.get(response, 'projects.length', 0) > 0;
                }
            }, (err) => { console.log(err); }
        );

        this.options = this.userService.options;

        const params = {
            unixName: this.user.unixName,
            siteName: this.siteName
        };
        this.titleService.setTitle('Welcome, ' + this.user.unixName, this.siteName);
    };

    ngAfterViewInit() {
        this.tourService.setTour('userWelcomeTour');
        this.tourService.runTour();
    }

    setCustomAvatar(newValue) {
        if (this.user.useCustomAvatar != newValue) {
            var updateData = {
                unixName: this.user.unixName,
                useCustomAvatar: newValue
            };
            this.userService.profile.save(updateData)
                .then(
                    () => {
                        this.uiService.message.showSuccess(
                            this.gfTranslateService.translate("Updated your avatar preference")
                        );
                        this.user.useCustomAvatar = newValue;
                    },
                    () => {
                        this.uiService.message.showWarning(
                            this.gfTranslateService.translate("Sorry, could not update your avatar preference")
                        );
                    }
                );

            this.user.useCustomAvatar = newValue;
        }
    };

    uploadAvatar(ev) {
        var file = _.get(ev, 'target.files[0]');
        if (!file) {
            return false;
        }

        const userUrl = this.avatarUrl;
        this.avatarUrl = '/core/img/ajax-loader.svg';

        var updateData = {
            unixName: this.user.unixName,
            file: file
        };
        this.userService.profile.save(updateData)
            .then(
                () => {
                    this.uiService.message.showSuccess(
                        this.gfTranslateService.translate("Updated your avatar image")
                    );
                },
                () => {
                    this.uiService.message.showWarning(
                        this.gfTranslateService.translate("Sorry, could not update your avatar image")
                    );
                }
            ).finally(() => {
                this.avatarUrl = userUrl;
            });
    };

    setUserStart(newValue) {
        if (this.userStart != newValue) {
            this.userStart = newValue;
        }
    };

    gotoPage(pageName) {
        this.stateService.go('home', { sitepage: pageName });
    }
}